import { BaseGQLService } from '../../common/services/BaseGQLService';
import { IntegrationsMapper } from '../mappers/IntegrationsMapper';
import { Integrations } from '../models/Integrations';

export const GET_INTEGRATIONS = `
query {
  viewer {
    organization {
      integrations {
        __typename
        ... on JiraIssueCollectorIntegration {
          issueCollectorCode
        }
        ... on JiraIntegration {
          url
          jiraAccessToken
        }
        ... on VenafiIntegration {
          url
          accessToken
          trustedCaCertificate
        }
        ... on TaniumIntegration {
          url
          accessToken
          trustedCaCertificate
          maxConcurrentRetrievals
          requestRate
        }
        ... on CrowdStrikeIntegration {
          baseUrl
          clientId
          clientSecret
        }
        ... on ServiceNowIntegration {
          instanceUrl
          userID
        }
      }
    }
  }
}
`;

export class IntegrationsRepository extends BaseGQLService {
  private readonly integrationsMapper = new IntegrationsMapper();

  async getIntegrations(): Promise<Integrations> {
    return this.query(GET_INTEGRATIONS, {}, (data) => this.integrationsMapper.mapGQLModel(data.viewer.organization.integrations));
  }
}
